import { Box, Divider, Typography } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import { UserWithSmopDetails } from "@saleor/auth";
import { switchAccountPath } from "@saleor/auth/urls";
import { savedAccountsLimit } from "@saleor/components/AppLayout/consts";
import { useSavedAccount } from "@saleor/components/AppLayout/SavedAccountContext";
import useNavigator from "@saleor/hooks/useNavigator";
import React, { useEffect } from "react";

import SavedAccountsList from "../SavedAccountsList/SavedAccountsList";
import useStyles from "./styles";

export interface SaveAccountDialogProps {
  user: UserWithSmopDetails;
}

interface MenuLoginExistingAccountProps {
  user: UserWithSmopDetails;
  setMenuState: (state: boolean) => void;
  handleLogout: () => void;
}

const MenuLoginExistingAccount: React.FC<MenuLoginExistingAccountProps> = ({
  handleLogout,
  user,
  setMenuState
}) => {
  const classes = useStyles({});
  const { savedAccounts, setRemoveAccount } = useSavedAccount();
  const [accountOptions, setAccountOptions] = React.useState([]);

  useEffect(() => {
    setAccountOptions(
      savedAccounts.filter(savedAccount => savedAccount.email !== user.email)
    );

    return () => {
      setAccountOptions([]);
    };
  }, []);

  const handleRemoveAccount = email => {
    setRemoveAccount(email);
    setMenuState(false);
  };

  return (
    <>
      <Divider className={classes.divider} />
      {accountOptions.length ? (
        <SavedAccountsList
          accountOptions={accountOptions}
          handleRemoveAccount={handleRemoveAccount}
          setMenuState={setMenuState}
          handleLogout={handleLogout}
        />
      ) : null}
      {savedAccounts.length < savedAccountsLimit ? <LoginAsMenuItem /> : null}
    </>
  );
};

const LoginAsMenuItem = () => {
  const navigate = useNavigator();
  const classes = useStyles({});

  const handleLoginExistingAccount = () => {
    navigate(switchAccountPath);
  };

  return (
    <MenuItem
      onClick={handleLoginExistingAccount}
      data-test="loginExistingAccountButton"
      className={classes.menuWrapper}
    >
      <Box className={classes.menuItem}>
        <PersonAddIcon className={classes.menuLabel} />
        <Typography component="span" className={classes.menuLabel}>
          Login an Existing Account
        </Typography>
      </Box>
    </MenuItem>
  );
};

MenuLoginExistingAccount.displayName = "MenuLoginExistingAccount";
export default MenuLoginExistingAccount;
